var module = angular.module('octopusApp.tasks');

module.controller('TasksIndexController', function ($scope, $timeout, $location, busy, pollLoop, octopusRepository, octopusPermissionSet, octopusFeatures) {
    var isLoading = $scope.isLoading = busy.create();
    $scope.tasks = null;
    $scope.skip = 0;
    $scope.skipActive = 0;
    $scope.filter = {
        name: "",
        nodeId: $location.search().serverNode
    };

    $scope.taskTypes = ["Deploy",
                        "Health", 
                        "AdHocScript", 
                        "AutoDeploy", 
                        "Backup", 
                        "Upgrade", 
                        "TestEmail", 
                        "TestAzureAccount", 
                        "Retention", 
                        "Delete", 
                        "SystemIntegrityCheck", 
                        "SyncCommunityActionTemplates", 
                        "SynchronizeBuiltInPackageRepositoryIndex",
                        "UpdateCalamari",
                        "Subscription",
                        "MigrationSpacePartialExport",
                        "MigrationSpaceImport",
                        "ConfigureLetsEncrypt"];
    $scope.loadRecentPage = loadRecentPage;
    $scope.loadActivePage = loadActivePage;
    $scope.refresh = refresh;
    $scope.searchTenants = searchTenants;
    $scope.searchEnvironments = searchEnvironments;
    $scope.searchProjects = searchProjects;
    $scope.selectedProjectChanged = selectedProjectChanged;
    $scope.selectedEnvironmentChanged = selectedEnvironmentChanged;
    $scope.selectedTenantChanged = selectedTenantChanged;

    $scope.$watch(function () {
        return octopusFeatures.isEnabled('IsMultiTenancyEnabled');
    }, function (isEnabled) {
        if(isEnabled){
            isLoading.promise(octopusRepository.Tenants.get().then(function (tenants) {
                $scope.tenants = tenants.Items;
            }));
        }
        $scope.filterDivCss = isEnabled ? "col-xs-2" : "col-xs-3";
        $scope.multiTenancyEnabled = isEnabled;
    });

    function loadRecentPage(skip) {
        $scope.skip = skip;
        loadTasks();
    }

    function loadActivePage(skipActive) {
        $scope.skipActive = skipActive;
        loadTasks();
    }

    function refresh() {
        $scope.skip = 0;
        $scope.skipActive = 0;
        loadTasks();
    }

    isLoading.promise(octopusPermissionSet.isAuthorized({
        permission: 'ProjectView',
        projectId: '*'
    }).then(function (yn) {
        return yn ? octopusRepository.Projects.get().then(function (data) {
            $scope.projects = data.Items;
        }) : null;
    }));

    isLoading.promise(octopusPermissionSet.isAuthorized({
        permission: 'EnvironmentView',
        environmentId: '*'
    }).then(function (yn) {
        return yn ? octopusRepository.Environments.get().then(function (data) {
            $scope.environments = data.Items;
        }) : null;
    }));

    isLoading.promise(octopusRepository.OctopusServerNodes.all().then(function (nodes) {
        $scope.nodes = nodes;
    }));

    function searchEnvironments(text, isOpen) {
        if(isOpen){
            isLoading.promise(octopusRepository.Environments.list({name: text}).then(function (data) {
                $scope.environments = data.Items;
            }));
        }
    }

    function searchProjects(text, isOpen) {
        if(isOpen){
            isLoading.promise(octopusRepository.Projects.list({name: text}).then(function (data) {
                $scope.projects = data.Items;
            }));
        }
    }

    function searchTenants(text, isOpen) {
        if(isOpen){
            isLoading.promise(octopusRepository.Tenants.list({name: text}).then(function (data) {
                $scope.tenants = data.Items;
            }));
        }
    }

    function selectedProjectChanged(item){
        if(item == undefined){
            isLoading.promise(octopusRepository.Projects.get().then(function (data) {
                $scope.projects = data.Items;
            }));
        }
        refresh();
    }

    function selectedEnvironmentChanged(item){
        if(item == undefined){
            isLoading.promise(octopusRepository.Environments.get().then(function (data) {
                $scope.environments = data.Items;
            }));
        }
        refresh();
    }

    function selectedTenantChanged(item){
        if(item == undefined){
            isLoading.promise(octopusRepository.Tenants.get().then(function (data) {
                $scope.tenants = data.Items;
            }));
        }
        refresh();
    }


    function loadTasks() {
        var options = {
            environment: $scope.filter.selectedEnvironment == undefined ? null : $scope.filter.selectedEnvironment.Id,
            name: $scope.filter.name || null,
            project: $scope.filter.selectedProject == undefined ? null : $scope.filter.selectedProject.Id,
            node: $scope.filter.nodeId,
            tenant: $scope.filter.selectedTenant == undefined ? null : $scope.filter.selectedTenant.Id
        };
        return isLoading.promise(octopusRepository.Tasks.filter(angular.extend({}, options, {
            skip: $scope.skip,
            active: false
        })).then(function (tasks) {
            return isLoading.promise(octopusRepository.Tasks.filter(angular.extend({}, options, {
                skip: $scope.skipActive,
                active: true
            })).then(function (activeTasks) {
                $scope.tasks = tasks;
                $scope.activeTasks = activeTasks;
            }));
        }));
    }

    pollLoop.create($scope, function () {
        return loadTasks();
    }).startImmediately();

});




//////////////////
// WEBPACK FOOTER
// ./app/areas/tasks/controllers/tasks_index_controller.js
// module id = 1476807086187589
// module chunks = 1